export default function Installtion() {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.5 9.33203H23.2647C23.9469 9.33203 24.5 9.85437 24.5 10.4987V22.1654C24.5 22.8097 23.9469 23.332 23.2647 23.332H4.73529C4.05306 23.332 3.5 22.8097 3.5 22.1654V9.33203Z"
                stroke="black"
                strokeWidth="1.75"
            />
            <path d="M3.5 7.58203V9.33203" stroke="black" strokeWidth="1.75" />
            <path d="M18.6665 13.416V16.3327" stroke="#85A3FF" strokeWidth="1.4" strokeLinecap="round" />
            <rect x="3.5" y="9.33203" width="21" height="14" rx="1.16667" stroke="#85A3FF" strokeWidth="1.4" />
            <path
                d="M3.5 7.58203C3.5 6.61553 4.2835 5.83203 5.25 5.83203H17.5C18.1443 5.83203 18.6667 6.35437 18.6667 6.9987V9.33203H5.25C4.2835 9.33203 3.5 8.54853 3.5 7.58203V7.58203Z"
                stroke="#85A3FF"
                strokeWidth="1.4"
            />
        </svg>
    );
}
